import { useEffect, useState } from 'react';
import { getPortalSession } from '../auth/portalSession';
import { LicenseManager } from 'ag-grid-enterprise';
import Loadingmini from './loadingmini';

export default function AuthenticatedApp({ children }) {
  const [agGridReady, setAgGridReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getPortalSession();
        if (!cancelled && res && res.license_key) {
          LicenseManager.setLicenseKey(res.license_key);
        }
      } catch (e) {
      } finally {
        if (!cancelled) setAgGridReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!agGridReady) return <Loadingmini />;
  return children;
}
